<template>
  <div class="vz-news">
    <page-header :title="title"/>
    <div class="public-container public-container-mobile">
      <vz-news-switcher class="mt-70 mb-40"/>
      <vz-news-list :tag="tag"/>
      <div v-if="tag === 'actions'" class="vz-news-description">
        <h2>Скидки транспортной компании «Возовоз»</h2>
        <p>
          «Возовоз» дорожит своими клиентами и поэтому регулярно проводит акции и предоставляет скидки на различные
          услуги. Каждый маркетинговый ход планируется, исходя из того, что для наших клиентов актуально на сегодняшний
          день.
        </p>
        <p>
          Любая программа лояльности рассчитана на определенную категорию партнеров. Для людей, которым нужно отправить
          посылку в другой город будет полезна одна программа, для бизнеса – другая. Скидки транспортной компании
          «Возовоз» помогают экономить на заборе груза, простое машины, доставке товаров по ряду направлений.
        </p>
        <p>
          Ежедневно мы перевозим более 700 000 кг грузов. Сеть региональных филиалов охватывает даже самые отдаленные
          уголки России. Наши машины обслуживают людей более чем в 100 000 населенных пунктов!
        </p>
        <h2>Правила действия акций</h2>
        <p>
          Мы активно работаем не только с крупным бизнесом, но и с интернет-магазинами. Онлайн торговля в России
          становится все более популярной. Чтобы упростить людям жизнь мы предлагаем специальные программы по доставке
          для
          интернет-магазинов и физических лиц.
        </p>
        <p>
          У маркетинговых программ нашей транспортной компании имеются свои правила. Обратите внимание, что для
          <nuxt-link to="/delivery-russia/" target="_blank">грузоперевозок</nuxt-link> акции не суммируются. Система автоматически
          выбирает наиболее выгодную. Это делается для того,
          чтобы не происходило путаницы, и система предложила человеку ту акцию, которая будет выгодна именно ему.
        </p>
        <p>
          «Возовоз» предлагает, как постоянные скидки, так и скидки с ограниченным сроком действия. Так, при оформлении
          заказа в личном кабинете каждый клиент получает скидку до 10%.
        </p>
        <p>
          Здесь же можно управлять отдельным маркетинговыми программами. Все акции публикуются на официальном сайте
          компании. Следите за нашими новостями, пользуйтесь скидками и развивайте свой бизнес вместе с нами!
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from "~/components/public/page-header.vue";
import VzNewsSwitcher from "~/components/public/news/vz-news-switcher.vue";
import VzNewsList from "~/components/public/news/vz-news-list.vue";
import {Article} from "~/types/article";

definePageMeta({
  path: '/:tag(news|actions)',
  keepalive: true
})

const title = computed(() => {
  return tag.value === 'actions' ? 'Акции' : 'Новости';
})

const tag = computed((): Article => {
  return (useRoute().params?.tag as any) || 'news'
})
</script>

<style lang="scss" scoped>
.vz-news {
  &-description {
    margin-bottom: 90px;

    @media screen and (max-width: $pub-sm) {
      margin-bottom: 70px;
    }

    h2 {
      text-align: left;
      margin-top: 60px;

      &:first-child {
        @media screen and (max-width: $pub-md) {
          margin-top: 20px;
        }
      }
    }

    p {
      margin-bottom: 15px;
    }
  }
}
</style>
